import { RecordContextType } from "../../components/record/Record";
import { leadsSearchSettings, treatmentsSearchSettings } from "../../utils/createSearchFilter";
import axios from "axios";
import { DoStuffAfterReturnType } from "../../types/groups.types";
import { MAKE_WEBHOOKS } from "../../utils/constants";
import { useStore } from "../../store/store";
import { AppDialogSessionContent } from "./components/send-meeting-to-client/AppDialogSessionContent";
import { SessionsActionButtons } from "./components/datagrid-action-buttons/SessionsActionButtons";

export const sessionsOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["group_one", "group_two", "group_thre"],
        fieldTypesToRemove: [],
    },

    fieldsWithExtraOptions: [
        {
            field: "treatment",
            createFilter: (inputValue: string) => treatmentsSearchSettings(inputValue),
        },

        {
            field: "status",
            defaultValue: "booked",
        },
        {
            field: "clinic_id",
            relatedTable: "clinics",
            displayTemplate: "{{name}}",
            enabled: true,
            sort: "id",
        },
        {
            field: "technician",
            sort: "user_id.first_name",
            enabled: true,
        },

        {
            field: "internal_meetings_participants",
            relatedTable: "technicians",
            displayTemplate: "{{user_id.first_name}} {{user_id.last_name}}",
            sort: "user_id.first_name",
            enabled: true,
        },
        {
            field: "lead",
            createFilter: (inputValue: string) => leadsSearchSettings(inputValue),
        },
        {
            field: "service",
            enabled: true,
            sort: "sort_order",
            filter: { sort_order: { _nnull: true } },
        },
        {
            field: "start_date",
            dateFormat: "eeee, dd/MM/yyyy HH:mm",
        },
        {
            field: "is_first_session",
            toggleShowFalseOnNull: true,
            hidden: {
                create: true,
                update: true,
            },
        },
    ],
    doStuffAfterUpdate: (data:any, updatedData:any ) => {
        const isCancelled = updatedData.status === "cancelled" || updatedData.status === "staff_unavailable";
        if (isCancelled && data.meeting_id) return deleteGMeeting(data.meeting_id);
        return updateGMeeting(data, updatedData);
    },
    createRelatedParams: (params: RecordContextType | undefined) => createSessionParams(params),
    extraOptions: {
        sort: "-start_date",
    },
    dataGridOptions: {
        checkboxSelection: true,
        customActionButtons: SessionsActionButtons,
    },
};

const createSessionParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;

    const getClinicId = (clinicId: any) => {
        if (!clinicId) return 1;
        return typeof clinicId === "object" ? clinicId.id : clinicId;
    };

    if (recordContext.entity === "treatments") {
        const clinicId = getClinicId(recordContext.item.client?.clinic_id);
        return `[treatments][id][*.*,client.user_id.*]=${recordContext.item.id}&[clinics][id]=${clinicId}&[clients][id]=${recordContext.item.client.id}`;
    }

    if (recordContext.entity === "clients") {
        const clinicId = getClinicId(recordContext.item?.clinic_id);
        return `[clients][id]=${recordContext.item.id}&[clinics][id]=${clinicId}`;
    }
};

export const updateGMeeting = async (data: any, updatedData:any) => {
    if (data.meeting_id) {
        const {appDialog} = useStore.getState()
        return new Promise<DoStuffAfterReturnType>((resolve) => {
            appDialog.createDialog({
                title: "Deseja atualizar os dados da Sessão em Google Meet?",
                contentAndActions: <AppDialogSessionContent oldData={data} newData={updatedData} />,
                onSubmit: async (title) => {
                    const response = await mutateGMeeting(data.id, false, title)
                    resolve(response)
                }
            })
        })   
    }
    return
}


export const deleteGMeeting = async (meetingId: string) => {
    const response = await mutateGMeeting(meetingId, true)
    return response
}

const mutateGMeeting = async (id: number | string, isDelete: boolean, title?:string) => {
    let successMessage;
    let errorMessage;

    if (isDelete) {
        successMessage = "A consulta/reunião online foi eliminada com sucesso";
        errorMessage = "A consulta/reunião online não foi eliminada";
    } else {
        successMessage = "A consulta/reunião online foi atualizada com sucesso";
        errorMessage = "A consulta/reunião online não foi atualizada";
    }

    const data = {
        id: id,
        isDelete: isDelete,
        title: title ?? null
    }

    try {
        const response = await axios.post(
            MAKE_WEBHOOKS.google_meet,
            data
        );

        const success = response.status === 204
        const responseForNotification : DoStuffAfterReturnType = {
            success: success,
            message: success ? successMessage : errorMessage,
            severity: success ? "success" : "error"
        }
        return responseForNotification
    } catch (error) {
        const axiosErrorMessage =
                axios.isAxiosError(error) && error.response?.data
                    ? error.response.data
                    : errorMessage;
                    
        const errorResponse: DoStuffAfterReturnType = {
            success: false,
            message: axiosErrorMessage,
            severity: "error"
        } 
        return errorResponse
    }
};